import { FC } from 'react'
import { useAppSelector } from '../../store/hooks'
import { Event as EventModel } from '../../models/Event'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { selectEventById } from '../../store/membership/EventReducer'
import { Space, Tag } from 'antd'
import dayjs from 'dayjs'

type Props = SBModelComponent<EventModel> & {}

const EventOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectEventById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Space size={0}>
      <Tag>{dayjs(item.start).format('DD/MM/YY')}</Tag> {item.en.title}
    </Space>
  )
}

type EventOptionType = { Option: typeof EventOption }

export { EventOption, type EventOptionType }
